import React from 'react';
import { CentroFormData, CiudadOption, EstadoOption } from '../../types/centro.types';

interface TabUbicacionProps {
    formData: CentroFormData;
    estados: EstadoOption[];
    ciudades: CiudadOption[];
    mapRef: React.RefObject<HTMLDivElement | null>;
    searchInputRef: React.RefObject<HTMLInputElement | null>;
    onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export const TabUbicacion: React.FC<TabUbicacionProps> = ({
    formData,
    estados,
    ciudades,
    mapRef,
    searchInputRef,
    onInputChange,
}) => (
    <>
        <div id="centro-ubicacion-direccion" className="row g-3 mb-3">
            <div className="col-md-6">
                <label className="fw-bold small mb-1">Dirección</label>
                <input
                    type="text"
                    className="form-control"
                    name="direccion"
                    value={formData.direccion}
                    onChange={onInputChange}
                    required
                />
            </div>
            <div className="col-md-3">
                <label className="fw-bold small mb-1">Estado</label>
                <select
                    className="form-select"
                    name="clave_estado"
                    value={formData.clave_estado}
                    onChange={onInputChange}
                    required
                >
                    <option value="">Elegir...</option>
                    {estados.map((e) => (
                        <option key={e.clave_estado} value={e.clave_estado}>
                            {e.estado}
                        </option>
                    ))}
                </select>
            </div>
            <div className="col-md-3">
                <label className="fw-bold small mb-1">Ciudad</label>
                <select
                    className="form-select"
                    name="clave_ciudad"
                    value={formData.clave_ciudad}
                    onChange={onInputChange}
                    required
                    disabled={!formData.clave_estado}
                >
                    <option value="">Elegir...</option>
                    {ciudades.map((c) => (
                        <option key={c.clave_ciudad} value={c.clave_ciudad}>
                            {c.ciudad}
                        </option>
                    ))}
                </select>
            </div>
        </div>
        <div className="row g-3 mb-3 border-top pt-3">
            <div className="col-md-6">
                <label className="fw-bold small mb-1">
                    <i className="fab fa-google" /> Buscar en el Mapa
                </label>
                <input type="text" ref={searchInputRef} className="form-control shadow-sm" placeholder="Buscar lugar..." />
            </div>
            <div className="col-md-3">
                <label className="fw-bold small mb-1">Lat</label>
                <input
                    type="number"
                    step="any"
                    className="form-control"
                    name="lat"
                    value={formData.lat}
                    onChange={onInputChange}
                    required
                />
            </div>
            <div className="col-md-3">
                <label className="fw-bold small mb-1">Lng</label>
                <input
                    type="number"
                    step="any"
                    className="form-control"
                    name="lng"
                    value={formData.lng}
                    onChange={onInputChange}
                    required
                />
            </div>
        </div>
        <div id="centro-ubicacion-mapa" className="rounded border overflow-hidden shadow-sm mb-3" style={{ height: '400px' }}>
            <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
        </div>
        <div id="centro-ubicacion-radio" className="row">
            <div className="col-md-8">
                <label className="fw-bold small d-flex justify-content-between">
                    <span>Cobertura (Radio)</span>
                    <span>{formData.radio}m</span>
                </label>
                <input
                    type="range"
                    className="form-range"
                    name="radio"
                    min="25"
                    max="500"
                    value={formData.radio}
                    onChange={onInputChange}
                />
            </div>
        </div>
    </>
);
